export const environment = {
    production: true,
    baseUrl: 'https://api.hairlines.app/api/v1/en',
    mapApiKey: 'AIzaSyAs3u_jV5iKyaamC-cXpaJCqANyld2YjsE', // Change this key in prod

    // STRIPE_KEY
    stripe: 'pk_live_51HIRdrAFQrnBnGI3txfyzgfPjfXJaOKO3NZJ2OeF0uYQg2s9AKYU2EpRrU1NkrjkP6s93xPeOAunrqwhUDUHX5gf006xTFYGmc',
    // stripe: 'pk_test_51HIRdrAFQrnBnGI3TmTo44QpdENrFM107sUQPqEhJx7J40eYeblIUt8LV714AOW3bsV4IDgOb9sUFFGDZXj4isTl00Aeo2TVgG',
    socket: 'https://api.hairlines.app'
};
